
<script>

  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  import _ from "lodash";

  import { supabase } from "../../libs/supabaseClient";

  import _system from '../../libs/system';
  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

export default {
   name: "knowledgeBase",
   data() {
      return {
         audience,
         searchQuery: '',
         vectors: [],
         modals: {}
      }
   },
   computed: {
   ...mapGetters('session', ['isLoggedIn', 'getUser', 'getWhiteLabel']),
   ...mapGetters("workspaces", ["workspaces", "currentWorkspace", "workspacesByUser"]),
   ...mapGetters('contacts', ['contacts']),
   },
   methods: {
   ...mapActions("session", ["setUser"]),
   ...mapActions("contacts", ["setContacts"]),
   ...mapActions("htmlModals", ["setEditUser"]),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),

   },
   created(){

    let payload = {};

    _system.services.chatbot.get(payload, (err, res) => {
          if(err) return iziToast.error({ position: 'bottomCenter', title: `${err.data.message}`, });
        this.vectors = res.data;
      }); 
   },
   mounted(){

   }
}

</script>

<template>


   <div class="ui grid">
      <div class="sixteen wide column centered">

         <div style=" background: #f1f1f1; margin: -1rem -1rem 1rem -1rem;" class="ui grid">
         <div class="four wide column">
<!--             <div @click="modals.upload = true" class="ui teal button float left">Import Contacts</div> -->
         </div>
         <div class="twelve wide column right aligned">
            <div class="ui input">
               <input v-model="searchQuery" type="text" placeholder="Search...">
            </div>
         </div>
         </div>

         <table v-if="contacts.length" class="ui celled table">
         <thead>
            <tr>
               <th>Text</th>
               <th>Url</th>
            </tr>
         </thead>
         <tbody>
            <tr v-for="(vector, i) in vectors" :key="contact.email">
               <td data-label="Name">
                  <h4 class="ui image header">
                     <img :src="'https://picsum.photos/id/' +(i+50)+ '/200'" class="ui mini rounded image">
                     <div class="content">
                        {{vector.input}}
                        <!-- <div class="sub header"></div> -->
                  </div>
                  </h4>
               </td>
               <td data-label="email">{{vector.productUri}}</td>
            </tr>
         </tbody>
         </table>
      </div>
   </div>


</template>


<style scoped>

.reportCard{
    padding: 1rem;
    border-radius: 5px;
    color: rgba(255,255,255, 0.9);
  }

  .yellowLish{
background-image: radial-gradient( circle farthest-corner at 46.6% 51.1%,  rgba(255,146,139,1) 0%, rgba(255,172,129,1) 90% );
  }
  .blueLish{
background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(75,108,183,1) 0%, rgba(55,82,141,1) 90% );
  }
  .greenLish{
background-image: radial-gradient( circle 347px at -1.2% 12%, rgb(44, 184, 168) 0%, rgb(240, 230, 142) 50% );
  }
  .geclish{
background-image: radial-gradient( circle 1027px at -1.2% 102%, #37528d 0%, #a16eed 30% )
  }
  .purpLish{
    background-image: linear-gradient( 109.6deg,  rgba(119,44,232,0.68) 11.5%, rgba(119,44,232,1) 91.2% );
  }
  .orangeLish{
    background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(255,122,78,1) 0%, rgba(255,205,112,1) 90% );
  }

.front{
  box-shadow: rgb(224, 224, 224) 0px 2px 4px !important;
  border-radius: 5px !important;
  background: #ffffff !important;
}

.active{
   font-weight:bold !important;
}
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.65) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 2px 54px rgba(99, 99, 99, 0.85);
   border: none;
   background: #eee;
}
</style>

./KnowledgeBase.vue



// WEBPACK FOOTER //
// src/components/dashboard/KnowledgeBase.vue